import { useContext } from 'react';
import { AppContext } from '../../app-context';
import { EMPTY_STRING } from '../../features/common/constants';
import { Snackbar } from '@mui/material';
import Alert from '@mui/material/Alert';

const MessageComponent = () => {
    const appData = useContext(AppContext);

    const isOpen = () => {
        return appData.errorMessage !== EMPTY_STRING || appData.successMessage !== EMPTY_STRING;
    }

    const handleClose = (event: any, reason: any) => {
        if (reason === 'clickaway') {
            return;
        }
        appData.setErrorMessage(EMPTY_STRING);
        appData.setSuccessMessage(EMPTY_STRING);
    };

    return (
        <div>
            <Snackbar open={isOpen()} autoHideDuration={6000} onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <div>
                    {appData.successMessage !== EMPTY_STRING && <Alert severity="success">
                        {appData.successMessage}
                    </Alert>}
                    {appData.errorMessage !== EMPTY_STRING && <Alert severity="error">
                        {appData.errorMessage}
                    </Alert>}
                </div>
            </Snackbar>
        </div>
    );
}


export default MessageComponent;